import { SyncStatus } from '@/enums/syncStatus';
import { useNotesRuntime } from '@/hooks/useNotes';
import styles from './SyncStatusBadge.module.css';

const LABEL: Record<SyncStatus, string> = {
  [SyncStatus.Idle]: 'Synced',
  [SyncStatus.Syncing]: 'Syncing…',
  [SyncStatus.Error]: 'Sync error',
  [SyncStatus.Stale]: 'Reconciled',
};

export function SyncStatusBadge() {
  const { syncStatus, lastError } = useNotesRuntime();
  return (
    <div
      className={`${styles.badge} ${styles[syncStatus]}`}
      role="status"
      aria-live="polite"
      title={lastError ?? undefined}
    >
      <span className={styles.dot} aria-hidden />
      {LABEL[syncStatus]}
    </div>
  );
}
